(function () {
    'use strict';

    angular
        .module('app')
        .controller('ManagePasswordController', ManagePasswordController);

   function ManagePasswordController(PasswordService, $cookies, $rootScope, $state, $scope, $location) {

        var vm = this;
        vm.userData = {
            email: "",
        };

        vm.isWebApiCallFailed = false;
       vm.forgotPassword = forgotPassword;

       $scope.loaderClosed = function () {
           cfpLoadingBar.complete();
       }

       $scope.loaderStart = function () {
           cfpLoadingBar.start();
       }

       $scope.goToUserPage = function (data) {
           $state.go(data.pageName, data.params);
       }

        function forgotPassword(isFormInvalid) {
            vm.isWebApiCallFailed = false;
            if (!isFormInvalid) {
                PasswordService.forgotPassword(vm.userData).then(function (data) {                    

                    if (!data) {
                        $rootScope.messageData = { code: "ForgotPasswordConfirmationMessage", title: "Forgot Password?" };
                        $state.go('displayMessage');
                    }
                    else
                    {
                        vm.isWebApiCallFailed = true;
                        vm.error = data;
                        $scope.forgotpasswordform.$setPristine();
                        $scope.forgotpasswordform.$setUntouched();
                    }
                }, function (error, status) {                    
                    vm.userData = {
                        email: ""
                    };
                    vm.isWebApiCallFailed = true;
                    vm.error = "Error";
                    $scope.forgotpasswordform.$setPristine();
                    $scope.forgotpasswordform.$setUntouched();
                });
            }
        }
    }
})();
